import type { LOYALTY_RULES_KEY } from "@/modules/loyalty/domain/repo/get-loyalty-rules";
import { pgTable, text, timestamp } from "drizzle-orm/pg-core";

export const MEMBERSHIP_RULES_KEY = "membership.rules";
export const MEMBERSHIP_QUOTA_KEY = "membership.quota";
export const MEMBERSHIP_DISCOUNTS_KEY = "membership.discounts";
export const MEMBERSHIP_ELIGIBLE_MENU_KEY = "membership.eligible_menu";
export const MEMBERSHIP_BIRTHDAY_KEY = "membership.birthday";
export const BACKUP_META_KEY = "backup.meta";

export type SystemSettingsKey =
  | typeof LOYALTY_RULES_KEY
  | typeof MEMBERSHIP_RULES_KEY
  | typeof MEMBERSHIP_QUOTA_KEY
  | typeof MEMBERSHIP_DISCOUNTS_KEY
  | typeof MEMBERSHIP_ELIGIBLE_MENU_KEY
  | typeof MEMBERSHIP_BIRTHDAY_KEY
  | typeof BACKUP_META_KEY;

export const systemSettings = pgTable("system_settings", {
  key: text("key").$type<SystemSettingsKey>().primaryKey(),
  value: text("value").notNull(),
  updatedAt: timestamp("updated_at", {
    withTimezone: true,
    mode: "date",
  }).notNull(),
});
